import { ADD_MESSAGE } from './actionCreator';

const initialState = {
  messages: [],
  loading: false,
  error: null,
};

const messagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload],
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};

export default messagesReducer;
